import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { lightTheme, RainbowKitProvider, } from '@rainbow-me/rainbowkit';
import { QueryClientProvider, QueryClient, } from '@tanstack/react-query';
import * as React from 'react';
import { WagmiConfig } from 'wagmi';
import { walletConfig } from "./walletConfig";
const queryClient = new QueryClient();
export default function RainbowKitConfig({ children }) {
    // 添加错误边界，捕获可能的导入错误
    React.useEffect(() => {
        // 验证关键对象是否存在
        if (!walletConfig) {
            console.error('walletConfig is undefined');
        }
        if (!queryClient) {
            console.error('queryClient is undefined');
        }
    }, []);
    try {
        return (_jsx(WagmiConfig, { config: walletConfig, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(RainbowKitProvider, { locale: 'en', theme: lightTheme({
                        accentColor: '#2E6AFF',
                        accentColorForeground: '#FFFFFF',
                        borderRadius: 'small',
                        fontStack: 'system',
                        overlayBlur: 'small',
                    }), children: children }) }) }));
    }
    catch (error) {
        console.error('RainbowKitConfig error:', error);
        // 返回降级UI，避免整个应用崩溃
        return _jsx(_Fragment, { children: children });
    }
}
;
